<div [formGroup]="form" *ngIf="form" [class]="!isValid() ? 'form-group input-group has-error' : 'form-group input-group'">
  <input [formControlName]="renderable.id"
       [type]="renderable.type"
       [attr.min]="renderable.min"
       [attr.max]="renderable.max"
       class="form-control"/>
</div>
